import { Image } from 'primereact/image';
import React, { useState, useEffect } from "react";
import Layout from "../../components/common/nav/initiator/nav.component";
import Login from '../../setup/auth/login.component';
import { RadioButton } from "primereact/radiobutton";
import { Calendar } from 'primereact/calendar';
import { InputText } from "primereact/inputtext";
import { Sidebar } from 'primereact/sidebar';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { Dropdown } from 'primereact/dropdown';
import CalendarIcon from '../../../src/assets/images/icon/calendar.svg';
import BoardsYet from '../../../src/assets/images/boards_yet.svg';
import '../../components/reportpdftemplate/base.min.css'
import '../../components/reportpdftemplate/fancy.min.css'
import '../../components/reportpdftemplate/main.css'
import { Link } from 'react-router-dom';
import { Li } from 'evergreen-ui';



export default function ServiceAgreementInitiatorReportList() {
    const [isAuthenticated, userHasAuthenticated] = useState(true);
    const [ingredient, setIngredient] = useState('');
    const [date, setDate] = useState(null);
    const [value, setValue] = useState('');
    const [AddNewForm, setAddNewForm] = useState(false);
    const [PSAview, setPSAview] = useState(false);
    const [PSAedit, setPSAedit] = useState(false);

    const [Report_sent, setReport_sent] = useState(false);
    const [position, setPosition] = useState('center');
    const show = (position) => {
    setPosition(position);
    setReport_sent(true);
    };


    const personalactionlist = [
      {
      FromTItle:'1',
      EMPLID:'15850',
      EMPLNAME:'record1',
      PROSTITLE:'Lab Asst - Teacher',
      EFFECDATE:'05/07/2023',
      SALARYRATE:'$3000',
      RATEOFPAY:'$5000',
      REASON:'Insufficient Fund',
      FUNDING:'Dept of HR',
      ACCONO:'52452269874',
     
      BUDGECODE:'0.0000 0 00007214',
    
  
    },
    {
      FromTItle:'1',
      EMPLID:'15850',
      EMPLNAME:'record1',
      PROSTITLE:'Lab Asst - Teacher',
      EFFECDATE:'05/07/2023',
      SALARYRATE:'$3000',
      RATEOFPAY:'$5000',
      REASON:'Insufficient Fund',
      FUNDING:'Dept of HR',
      ACCONO:'52452269874',
 
      BUDGECODE:'0.0000 0 00007214',
      
    },
    {
      FromTItle:'1',
      EMPLID:'15850',
      EMPLNAME:'record1',
      PROSTITLE:'Lab Asst - Teacher',
      EFFECDATE:'05/07/2023',
      SALARYRATE:'$3000',
      RATEOFPAY:'$5000',
      REASON:'Insufficient Fund',
      FUNDING:'Dept of HR',
      ACCONO:'52452269874',
     
      BUDGECODE:'0.0000 0 00007214',
   
    },
    {
      FromTItle:'1',
      EMPLID:'15850',
      EMPLNAME:'record1',
      PROSTITLE:'Lab Asst - Teacher',
      EFFECDATE:'05/07/2023',
      SALARYRATE:'$3000',
      RATEOFPAY:'$5000',
      REASON:'Insufficient Fund',
      FUNDING:'Dept of HR',
      ACCONO:'52452269874',

      BUDGECODE:'0.0000 0 00007214',
     
    },
    {
      FromTItle:'1',
      EMPLID:'15850',
      EMPLNAME:'record1',
      PROSTITLE:'Lab Asst - Teacher',
      EFFECDATE:'05/07/2023',
      SALARYRATE:'$3000',
      RATEOFPAY:'$5000',
      REASON:'Insufficient Fund',
      FUNDING:'Dept of HR',
      ACCONO:'52452269874',
     
      BUDGECODE:'0.0000 0 00007214',
    },
    ]
  
     // status


  const statusBodyTemplate = (product) => {
    return <Tag value={product.STATUS} severity={getSeverity(product)}></Tag>;
};

const getSeverity = (product) => {
  switch (product.STATUS) {
      case 'Submitted':
          return 'success';

      case 'Approved':
          return 'warning';

      case 'Rejected':
          return 'danger';

      default:
          return null;
  }
};
//status end

    const [statuses] = useState(['Approved', 'Pending', 'Rejected', 'Submitted', 'Reviewed And Resubmited']);
  const statusItemTemplate = (option) => {
    return <Tag value={option} severity={TaskStatusSL(option)} />;
  };

  const TaskStatusSL = (product) => {
    switch (product.status) {

      case 'Rejected':
        return 'danger';

      case 'Pending':
        return 'warning';

      case 'Submitted':
        return 'info';

      case 'Approved':
        return 'success';

      case 'Approved (P)':
        return 'success';

      case 'Reviewed And Resubmited':
        return 'success';

      default:
        return null;
    }
  };

  const TaskStatusSLA = (product) => {
    // console.log("product", product.status);
    return <Tag value={product.status} severity={TaskStatusSL(product)}></Tag>;
  };

  const statusRowFilterTemplate = (options) => {
    return (
      <Dropdown value={options.value} options={statuses} onChange={(e) => options.filterApplyCallback(e.value)} itemTemplate={statusItemTemplate} placeholder="Select" className="p-column-filter custDropdown" showClear style={{ minWidth: '7rem' }} />
    );
  };

  const alljobactionContent = (row) => {
    return (
      <div className="flex justify-center w-full gap-2" >
        <div className='cursor-pointer' onClick={() => setPSAview(true)}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></div>
        <div className='cursor-pointer' onClick={() => setAddNewForm(true)}><i className="gusd-edit text-[#667085] text-[20px] font-meduim"></i></div>


        {/* {
          row.status === "Submitted" ? <Link to='#' className="py-2 px-2.5" onClick={() => onClickViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
            row.status === "Approved" ? <Link to='#' className="py-2 px-2.5" onClick={() => onClickViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
              row.status === "Reviewed & resubmitted" ? <Link to='#' className="py-2 px-2.5" onClick={() => onClickViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
                <Link to='#' className="py-2 px-2.5"
                  onClick={() =>
                    onClickEditPopUp(row)
                  }><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link>
        } */}
      </div>
    );
  };

  return isAuthenticated ? (
    <>
      <Layout pageTitle="Report" activeMenu="Initiator">
      <div className="report-wrapper pt-24 md:pt-28 xl:pt-[2.083vw]">
       <div className='flex max-sm:w-full justify-start md:justify-end'>
        <div className='grid grid-cols-2 sm:grid-cols-4 gap-2'>
        <Link to={''} className='bg-[#EFF8FF] opacity-[0.5] xl:py-[0.625vw] py-[10px] xl:px-[0.885vw] px-[15px] rounded-lg Shadow_xs flex items-center justify-center space-x-2 text-[#667085] font-medium text-xs xl:text-[0.781vw] cursor-pointer'><span>Form History</span></Link>
        <Link to={''} className='bg-[#EFF8FF] xl:py-[0.625vw] py-[10px] xl:px-[0.885vw] px-[15px] rounded-lg Shadow_xs flex items-center justify-center space-x-2 text-[#2D5BE5] font-medium text-xs xl:text-[0.781vw] cursor-pointer'><i className='gusd-print-outline'></i><span>Print</span></Link>
        <Link to={'/personnelactionsreports/Initiatenewform'} className='bg-[#EFF8FF] xl:py-[0.625vw] py-[10px] xl:px-[0.885vw] px-[15px] rounded-lg Shadow_xs flex items-center justify-center space-x-2 text-[#2D5BE5] font-medium text-xs xl:text-[0.781vw] cursor-pointer'><span>Cancel</span></Link>
        <Link to={''} className='bg-[#113699] xl:py-[0.625vw] py-[10px] xl:px-[0.885vw] px-[15px] rounded-lg Shadow_xs flex items-center justify-center space-x-2 text-[#FFFFFF] font-medium text-xs xl:text-[0.781vw] cursor-pointer'><span>Submit</span></Link>
        
        </div>        
      </div>     

      <div className='mt-5'>
        <div className='grid md:grid-cols-3 xl:grid-cols-5 xl:gap-[1.302vw] gap-5'>
        {/*col*/}
        <div>
          <div className='text-[#344054] font-medium text-xs xl:text-[0.729vw]'>Select One</div>
          <div className='flex items-center gap-3 mt-3'>
          <div className="flex items-center">
          <RadioButton inputId="ingredient1" name="pizza" value="Cheese" onChange={(e) => setIngredient(e.value)} checked={ingredient === 'Cheese'} />
          <label htmlFor="ingredient1" className="ml-2 text-[#1E3E5A] font-normal text-sm xl:text-[0.885vw]">Certificated</label>
          </div>
          <div className="flex items-center">
          <RadioButton inputId="ingredient1" name="pizza" value="Cheese" onChange={(e) => setIngredient(e.value)} checked={ingredient === 'Cheese'} />
          <label htmlFor="ingredient1" className="ml-2 text-[#1E3E5A] font-normal text-sm xl:text-[0.885vw]">Classified</label>
          </div>
          </div>
        </div>
        {/*col*/}
        <div>
        <div className='text-[#344054] font-medium text-xs xl:text-[0.729vw]'>Board Meeting Date</div>
        <div className='relative mt-1'>
        <div className='absolute z-10 top-3 left-3'><Image src={CalendarIcon} width={"16"} height={"16"} alt='CalendarIcon' /></div>
        <Calendar value={date} onChange={(e) => setDate(e.value)} dateFormat="mm/dd/yy" placeholder='Choose Date' className='w-full placeholder:text-[#667085] custm_calender xl:h-[2.292vw] h-[40px]' />
        </div>
        </div>
        {/*col*/}
        <div>
        <div className='text-[#344054] font-medium text-xs xl:text-[0.729vw]'>Personnel Report No</div>
        <div className='mt-1'>
        <InputText value={value} onChange={(e) => setValue(e.target.value)} placeholder='Enter the Number' className='w-full placeholder:text-[#667085] xl:h-[2.292vw] h-[40px]' />
        </div>
        </div>
        {/*col*/}
        <div>
        <div className='text-[#344054] font-medium text-xs xl:text-[0.729vw]'>Location</div>
        <div className='custm_inpute mt-1 relative'>
        <span className="p-input-icon-left w-full"><i className="gusd-search" />
        <InputText placeholder="Type your Location" className='w-full placeholder:text-[#667085] xl:h-[2.292vw] h-[40px]' />
        </span>
        </div>
        </div>
        {/*col*/}
        <div>
        <div className='text-[#344054] font-medium text-xs xl:text-[0.729vw]'>Action to be Taken</div>
        <div className='custm_inpute mt-1 relative'>
        <span className="p-input-icon-left w-full"><i className="gusd-search" />
        <InputText placeholder="Type the Action" className='w-full placeholder:text-[#667085] xl:h-[2.292vw] h-[40px]' />
        </span>
        </div>
        </div>
        {/*col*/}
        </div>
      </div>
    

        <div className='flex items-center justify-between xl:mt-[2.083vw] mt-[35px]'>
            <div className='text-[#344054] font-semibold text-lg xl:text-[1.042vw]'>Personnel Action List</div>
            {/* <div className='bg-[#113699] Shadow_xs xl:py-[0.625vw] py-[10px] xl:px-[0.938vw] px-[16px] flex items-center space-x-2 text-white font-semibold text-sm rounded-lg cursor-pointer' onClick={() => setAddNewForm(true)}><i className='gusd-pluse-circle'></i><span>Add New </span></div> */}
        </div>

        <div className="initiator mt-5 bg-white p-2 rounded-lg">
                

                  <DataTable className="custpaginator custIcons custmBtnTable custTable " scrollable value={personalactionlist} paginator paginatorTemplate="PrevPageLink PageLinks NextPageLink" rows={11}>
                    <Column field="FromTitle" header="Form Title" sortable style={{ minWidth: '8rem' }}></Column>
                    <Column field="EMPLID" header="Employee ID"  sortable style={{ minWidth: '8rem' }}></Column>
                    <Column field="EMPLNAME" header="Employee Name" style={{ minWidth: '10rem' }} sortable></Column>
                    <Column field="PROSTITLE" header="Position Title (To - From)" style={{ minWidth: '14rem' }} sortable></Column>
                    <Column field="EFFECDATE" header="Effective Dates |(From - To)"  style={{ minWidth: '14rem' }} sortable ></Column>
                    <Column field="SALARYRATE" header="Salary Rate" sortable style={{ minWidth: '8rem' }}></Column>
                    <Column field="RATEOFPAY" header="Rate of Pay (Note to Exceed)" sortable style={{ minWidth: '14rem' }}></Column>
                    <Column field="REASON" header="Reason" sortable style={{ minWidth: '5rem' }}></Column>
                    <Column field="FUNDING" header="Funding Source" sortable style={{ minWidth: '10rem' }}></Column>
                    <Column field="ACCONO" header="Account Number" sortable style={{ minWidth: '10rem' }}></Column>
                    <Column field="BUDGECODE" header="Budget Code" sortable style={{ minWidth: '8rem' }}></Column>
                   
                  </DataTable>
                </div>


      </div>
      </Layout >

      <Sidebar visible={AddNewForm} position="right" onHide={() => setAddNewForm(false)} className='Add_new_Form' style={{width:'30vw', background:'#F5F6F7'}}>
      <div className='xl:py-[1.667vw] py-7 xl:px-[1.250vw] px-5 xl:space-y-[1.250vw] space-y-2'>
        <div className='cursor-pointer' onClick={() => setAddNewForm(false)}><i className='gusd-close-sidebar'></i></div>
        <div className='text-[#113699] font-semibold text-base xl:text-[0.833vw] -tracking-[0.32px]'>New Form</div>
        <div className='xl:space-y-[0.938vw] space-y-2'>
        {/*col*/}
        <div>
        <div className='text-[#344054] font-medium text-xs xl:text-[0.729vw]'>Employee ID</div>
        <div className='custm_inpute mt-1 relative'>
        <span className="p-input-icon-left w-full"><i className="gusd-search" />
        <InputText placeholder="Type the Action" className='w-full placeholder:text-[#667085] md:h-[2.292vw] h-[40px]' />
        </span>
        </div>
        </div>
        {/*col*/}
        <div>
        <div className='text-[#344054] font-medium text-xs xl:text-[0.729vw]'>Employee Name</div>
        <div className='custm_inpute mt-1 relative'>
        <span className="p-input-icon-left w-full"><i className="gusd-search" />
        <InputText placeholder="Type the Action" className='w-full placeholder:text-[#667085] md:h-[2.292vw] h-[40px]' />
        </span>
        </div>
        </div>
        {/*col*/}
        <div>
        <div className='text-[#344054] font-medium text-xs xl:text-[0.729vw]'>Position Title</div>
        <div className='grid grid-cols-2 gap-3'>
        <div className='custm_inpute mt-1 relative'>
        <span className="p-input-icon-left w-full"><i className="gusd-search" />
        <InputText placeholder="To" className='w-full placeholder:text-[#667085] md:h-[2.292vw] h-[40px]' />
        </span>
        </div>
        <div className='custm_inpute mt-1 relative'>
        <span className="p-input-icon-left w-full"><i className="gusd-search" />
        <InputText placeholder="From" className='w-full placeholder:text-[#667085] md:h-[2.292vw] h-[40px]' />
        </span>
        </div>
        </div>        
        </div>
        {/*col*/}
        {/*col*/}
        <div>
        <div className='text-[#344054] font-medium text-xs xl:text-[0.729vw]'>Effective Dates</div>
        <div className='grid grid-cols-2 gap-3'>
        <div className='relative mt-1'>
        <div className='absolute z-10 top-3 left-3'><Image src={CalendarIcon} width={"16"} height={"16"} alt='CalendarIcon' /></div>
        <Calendar value={date} onChange={(e) => setDate(e.value)} dateFormat="mm/dd/yy" placeholder='From' className='w-full placeholder:text-[#667085] custm_calender md:h-[2.292vw] h-[40px]' />
        </div>
        <div className='relative mt-1'>
        <div className='absolute z-10 top-3 left-3'><Image src={CalendarIcon} width={"16"} height={"16"} alt='CalendarIcon' /></div>
        <Calendar value={date} onChange={(e) => setDate(e.value)} dateFormat="mm/dd/yy" placeholder='To' className='w-full placeholder:text-[#667085] custm_calender md:h-[2.292vw] h-[40px]' />
        </div>
        </div>        
        </div>
        {/*col*/}
        {/*col*/}
        <div>
        <div className='text-[#344054] font-medium text-xs xl:text-[0.729vw]'>Salary Rate</div>
        <div className='mt-1'>
        <InputText value={value} onChange={(e) => setValue(e.target.value)} placeholder='Enter the Salary' className='w-full placeholder:text-[#667085] md:h-[2.292vw] h-[40px]' />
        </div>
        </div>
        {/*col*/}
        {/*col*/}
        <div>
        <div className='text-[#344054] font-medium text-xs xl:text-[0.729vw]'>Rate of Pay (Not to Exceed)</div>
        <div className='mt-1'>
        <InputText value={value} onChange={(e) => setValue(e.target.value)} placeholder='Enter the Rate' className='w-full placeholder:text-[#667085] md:h-[2.292vw] h-[40px]' />
        </div>
        </div>
        {/*col*/}
        {/*col*/}
        <div>
        <div className='text-[#344054] font-medium text-xs xl:text-[0.729vw]'>Reason</div>
        <div className='mt-1'>
        <InputText value={value} onChange={(e) => setValue(e.target.value)} placeholder='Enter the Reason' className='w-full placeholder:text-[#667085] md:h-[2.292vw] h-[40px]' />
        </div>
        </div>
        {/*col*/}
        {/*col*/}
        <div>
        <div className='text-[#344054] font-medium text-xs xl:text-[0.729vw]'>Funding Souce</div>
        <div className='mt-1'>
        <InputText value={value} onChange={(e) => setValue(e.target.value)} placeholder='Enter the Source' className='w-full placeholder:text-[#667085] md:h-[2.292vw] h-[40px]' />
        </div>
        </div>
        {/*col*/}
        {/*col*/}
        <div>
        <div className='text-[#344054] font-medium text-xs xl:text-[0.729vw]'>Account Number</div>
        <div className='mt-1'>
        <InputText value={value} onChange={(e) => setValue(e.target.value)} placeholder='Enter the Account Number' className='w-full placeholder:text-[#667085] md:h-[2.292vw] h-[40px]' />
        </div>
        </div>
        {/*col*/}
        {/*col*/}
        <div>
        <div className='text-[#344054] font-medium text-xs xl:text-[0.729vw]'>Budget Code</div>
        <div className='custm_inpute mt-1 relative'>
        <span className="p-input-icon-left w-full"><i className="gusd-search" />
        <InputText placeholder="Type the Code" className='w-full placeholder:text-[#667085] md:h-[2.292vw] h-[40px]' />
        </span>
        </div>
        </div>
        {/*col*/}

        <div className='flex items-center justify-between mt-5'>
          <div className='text-[#344054] font-medium text-xs xl:text-[0.781vw] bg-white border border-[#D0D5DD] rounded-lg xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[13px] cursor-pointer' onClick={() => setAddNewForm(false)}>Clear</div>
          <div className='text-[#FAFBFF] font-medium text-xs xl:text-[0.781vw] bg-[#113699] border border-[#113699] rounded-lg xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[13px] flex items-center
           space-x-2 cursor-pointer' onClick={() => show('right')}><i className='gusd-check'></i><span>Apply</span></div>
        </div>
        </div>
      </div>
      </Sidebar>

      <Dialog header="Header" visible={Report_sent} position={position} style={{ width: '20vw' }} onHide={() => setReport_sent(false)} draggable={false} resizable={false} className='Report_sent'>
                <div className='xl:p-[1.250vw] p-[20px] space-y-3'>
                  <div className='text-[#0487C8] font-medium text-base xl:text-[0.938vw] space-x-2'><i className='gusd-check-circle'></i><span>Report sent</span></div>
                  <div className='text-[#344054] font-normal text-[12px] xl:text-[0.781vw]'>Your report has been sent successfully!</div>
                  <div className='grid grid-cols-2 gap-3 place-content-stretch place-items-stretch'>
                    <div className='bg-[#F9FAFB] rounded-lg shadow_xs text-[#344054] text-center font-medium text-sm xl:py-[0.521vw] py-2 cursor-pointer' onClick={() => setReport_sent(false)} >Close</div>
                    <div className='bg-[#113699] rounded-lg shadow_xs text-[#FFFFFF] text-center font-medium text-sm xl:py-[0.521vw] py-2 cursor-pointer'>Add New </div>
                  </div>
                </div>
            </Dialog>
    </>
  ) : (
    <Login sessionExpired={1} />
  );
}